import { resolveApiRoot, resolveSiteLinks, resolveTurnstileSiteKey } from '@kkf/design'

/**
 * The three venture apps, by absolute URL.
 *
 * The Foundation site is the entry point: the resort, the garage and the Partners each
 * live on their own subdomain now, so every link that used to be `/resort*` resolves
 * through here. `import.meta.env` is read in the app rather than inside the design system
 * because `import.meta` is a bundler-specific global and `resolveSiteLinks` has to stay
 * importable from React Native. Defaults are the production hosts — see `.env.example`.
 */
export const LINKS = resolveSiteLinks(import.meta.env)

/**
 * Cloudflare Turnstile's site key.
 *
 * The public half of the pair — it is meant to be in the bundle, which is why it carries
 * the `VITE_` prefix like every other variable here. The secret half lives in `app_api`'s
 * `.env.secrets` and never reaches a browser.
 *
 * **Empty is a valid value, and it is the value today.** There is no Turnstile account yet,
 * so an unset key renders no widget and leaves the form working. The server's half matches:
 * `app_api` treats a missing token as a failure **only when it has a secret configured**, so
 * an unset key cannot accidentally refuse every submission.
 *
 * Read through `@kkf/design` rather than from `import.meta.env` here, for the reason
 * `resolveSiteLinks` is: one resolver for five apps, and one that stays importable from
 * React Native. The variable is in all five `.env.example` files and belongs in all five
 * Cloudflare Pages projects — it was in this app's and unread until 2026-09-21.
 */
export const TURNSTILE_SITE_KEY = resolveTurnstileSiteKey(import.meta.env)

/**
 * Where the browser finds `app_api`.
 *
 * **Read by this app as of 2026-09-25**, when the appeals moved out of `data/donations.ts`
 * and into the API. It is the same resolver the other four front ends use: the production
 * origin in a production build, and the Vite dev proxy on `/api` in development — never
 * production from a laptop, because an API root that defaults to production would record a
 * gift into `kkf_prod` from `npm run dev`. See `resolveApiRoot`, and the proxy in this app's
 * `vite.config.ts`.
 */
export const API_ROOT = resolveApiRoot(import.meta.env)
